function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_787_2833)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.05 0H1.95C.87 0 0 .87 0 1.95v16.1C0 19.13.87 20 1.95 20h16.1c1.08 0 1.95-.87 1.95-1.95V1.95C20 .87 19.13 0 18.05 0z",
  fill: "url(#paint0_linear_787_2833)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.67 14.03l-5.64-3.78h-.01-.01a.02.02 0 000 .02v6.8a.44.44 0 00.68.35l4.98-3.4z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 8.75L5 10.24l5.67 3.79L13 12.44l-5.5-3.7z",
  fill: "#FCE2C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.06 9.64L5.68 2.58a.44.44 0 00-.68.36v4.15a.02.02 0 000 .01l8 5.34h.01l3.05-2.08a.44.44 0 000-.72z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_787_2833)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.13 10c1.03 0 1.87.84 1.87 1.88v16.24c0 1.04-.84 1.88-1.88 1.88H11.88A1.88 1.88 0 0110 28.12V11.88c0-1.03.84-1.87 1.88-1.87h16.24z",
  fill: "url(#paint1_linear_787_2833)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.42 12.18l-2.88 3.03h10.04c.08 0 .16-.04.21-.1l2.37-2.5a.32.32 0 00.07-.33.3.3 0 00-.28-.2h-9.32a.29.29 0 00-.21.1zM16.42 27.4l-2.88-3.02h10.04c.08 0 .16.03.21.09l2.37 2.5c.09.08.11.22.07.33a.3.3 0 01-.28.2h-9.32a.29.29 0 01-.2-.1",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".74",
  d: "M16.46 15.2h-2.92v9.18h2.92V15.2z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_787_2833",
  x1: "10",
  y1: "0",
  x2: "10",
  y2: "20",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A731"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#EE7B2E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_787_2833",
  x1: "10",
  y1: "10",
  x2: "10",
  y2: "30",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#97C93D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#3D9544"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_787_2833"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_787_2833"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(10 10)",
  d: "M0 0h20v20H0z"
}))));